import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses, TooltipProps } from "@mui/material/Tooltip";

export interface ErrorTooltipProps extends Omit<TooltipProps, "classes"> {
  className?: string;
}

export const ErrorTooltip = styled(({ className, ...props }: ErrorTooltipProps) => <Tooltip {...props} classes={{ popper: className }} />)(
  ({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.error.light,
      color: theme.palette.error.contrastText,
      fontSize: "0.875rem",
      maxWidth: 300,
      "& .MuiTooltip-arrow": {
        color: theme.palette.error.light,
      },
    },
  })
);

export default ErrorTooltip;
